import { useDashboardLayoutRedesignEnabled } from "byzantine/src/dbbl/businessLogic/modules/dashboard/hooks";
import { useBreakpoints } from "@narmi/design_system";
import PromotionCard from "../PromotionCard/PromotionCard";
import MarketingCard from "../MarketingCard/MarketingCard";
import useIsMarketingBannersEnabled from "../MarketingImage/hooks";
import useWelcomeOffer from "./useWelcomeOffer";
import BorderedMarketingCard from "../MarketingCard/BorderedMarketingCard";
import BorderedPromotionCard from "../PromotionCard/BorderedPromotionCard";

const MarketingCardContainer = () => {
  const welcomeOffer = useWelcomeOffer();
  const isMarketingBannersEnabled = useIsMarketingBannersEnabled();
  const isDashboardLayoutRedesignEnabled = useDashboardLayoutRedesignEnabled();
  const { m } = useBreakpoints();

  if (isDashboardLayoutRedesignEnabled && m) return null;

  if (
    isDashboardLayoutRedesignEnabled &&
    welcomeOffer &&
    !isMarketingBannersEnabled
  ) {
    return <BorderedPromotionCard promotion={welcomeOffer} />;
  } else if (welcomeOffer && !isMarketingBannersEnabled) {
    return <PromotionCard promotion={welcomeOffer} />;
  } else if (isDashboardLayoutRedesignEnabled && isMarketingBannersEnabled) {
    return (
      <BorderedMarketingCard address="31b65103-a70b-4a35-8245-124a91fe1fe0" />
    );
  } else if (isMarketingBannersEnabled) {
    return <MarketingCard address="31b65103-a70b-4a35-8245-124a91fe1fe0" />;
  }

  return null;
};

export default MarketingCardContainer;
